import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AppCard from '../components/AppCard';
import { API_URL } from '../config';
import '../styles/Home.css';

interface AppSummary {
  id: string;
  name: string;
  category: string;
  rating: number;
  price: number;
  icon: string;
  description: string;
}

const Categories: React.FC = () => {
  const [apps, setApps] = useState<AppSummary[]>([]);
  const [loading, setLoading] = useState(true);
  const categories = ['Junior Sitter (Getting Certified)', 'Junior Sitter', 'Certified Sitter', 'Junior Sitter (Training)'];

  useEffect(() => {
    fetch(`${API_URL}/api/apps`)
      .then(res => res.json())
      .then(data => {
        setApps(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching apps:', err);
        setLoading(false);
      });
  }, []);

  if (loading) return <div className="home-container"><div className="loading-state">Loading categories...</div></div>;

  return (
    <div className="home-container">
      <h1 style={{ textAlign: 'center', marginBottom: '40px', color: 'var(--primary-color)' }}>Browse by Category</h1>
      
      {categories.map(category => {
        const categoryApps = apps.filter(app => app.category === category);
        if (categoryApps.length === 0) return null;

        return (
          <section key={category} style={{ marginBottom: '60px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', borderBottom: '2px solid rgba(0,0,0,0.05)', paddingBottom: '10px' }}>
              <h2 style={{ margin: 0 }}>{category}</h2>
              <Link to={`/?search=${category}`} style={{ color: 'var(--primary-color)', fontWeight: 600 }}>View All →</Link>
            </div>
            <div className="app-grid">
              {categoryApps.slice(0, 3).map(app => (
                <AppCard key={app.id} {...app} />
              ))}
            </div>
          </section>
        );
      })}
    </div>
  );
};

export default Categories;
